import React from 'react';
import { default as Search } from './Search';

const App = () => (
  <div>
    <Search />
  </div>
);

export default App;
